import { render, staticRenderFns } from "./business.vue?vue&type=template&id=48e01f0a&scoped=true&"
import script from "./business.vue?vue&type=script&lang=js&"
export * from "./business.vue?vue&type=script&lang=js&"
import style0 from "./business.vue?vue&type=style&index=0&id=48e01f0a&prod&scoped=true&lang=css&"
import style1 from "./business.vue?vue&type=style&index=1&id=48e01f0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e01f0a",
  null
  
)

export default component.exports